import {
	Badge,
	Box,
	Card,
	Group,
	Skeleton,
	Stack,
	Text,
	ThemeIcon,
	Title,
} from "@mantine/core";
import { Coins } from "lucide-react";
import type { KeuanganAid } from "@/api/transforms/keuangan-apbdes";
import { formatM } from "@/components/keuangan";
import { useIsDark } from "@/hooks/useIsDark";
import { useTranslate } from "@/hooks/useTranslate";

interface DanaBantuanCardProps {
	aid: KeuanganAid[];
	loading: boolean;
}

export function DanaBantuanCard({ aid, loading }: DanaBantuanCardProps) {
	const t = useTranslate();
	const dark = useIsDark();

	return (
		<Card
			data-ai-target="keuangan.dana-bantuan"
			p="md"
			radius="xl"
			withBorder
			style={{
				backgroundColor: "var(--app-card)",
				borderColor: "var(--app-border)",
				boxShadow: "var(--mantine-shadow-xs)",
			}}
			h="100%"
		>
			<Group gap="xs" mb="md">
				<ThemeIcon
					color="darmasaba-navy.7"
					variant="filled"
					size="sm"
					radius="sm"
				>
					<Coins size={14} />
				</ThemeIcon>
				<Title order={4} c={dark ? "white" : "gray.9"}>
					{t.keuanganAnggaran.danaBantuan}
				</Title>
			</Group>
			{loading ? (
				<Skeleton height={200} radius="md" />
			) : (
				<Stack gap="sm">
					{aid.length > 0 ? (
						aid.map((fund) => (
							<Card
								key={fund.source}
								p="sm"
								radius="lg"
								style={{
									backgroundColor: "var(--app-info-subtle)",
									borderColor: "transparent",
									transition: "background-color 0.15s ease",
								}}
							>
								<Group justify="space-between" align="center">
									<Box>
										<Text size="sm" fw={600} c={dark ? "white" : "gray.9"}>
											{fund.source}
										</Text>
										<Text size="xs" c="dimmed">
											Rp {formatM(fund.amount)}
										</Text>
									</Box>
									<Badge
										variant="light"
										color={fund.status === "cair" ? "green" : "yellow"}
										radius="sm"
										fw={600}
									>
										{fund.status === "cair"
											? t.keuanganAnggaran.cair
											: t.keuanganAnggaran.proses}
									</Badge>
								</Group>
							</Card>
						))
					) : (
						<Text size="sm" c="dimmed" ta="center" py="xl">
							{t.keuanganAnggaran.tidakAdaBantuan}
						</Text>
					)}
				</Stack>
			)}
		</Card>
	);
}
